import React from 'react'

const DailyInspectionReport = () => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card" id={1}>
                    <div className="card-body">
                        <div className="checklist-title-bx">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-center">
                                        <h4>DAILY INSPECTION REPORT</h4>
                                        <p>
                                            Following to be checked and confirmed before official delivery
                                            of the vessel
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="report-index-top">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="hd-s2 pl10">
                                                    <p>Project</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <select
                                                        className="form-select"
                                                        defaultValue=""
                                                    >
                                                        <option>Select Project</option>
                                                        <option>CL-001</option>
                                                        <option>CL-002</option>
                                                        <option>CL-003</option>
                                                        <option>CL-004</option>
                                                    </select>
                                                </td>
                                                <td className="hd-s2 pl10">
                                                    <p>Hull No</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <div className="hull-select-box">
                                                        <select className="form-select">
                                                            <option>Select Hull Number</option>
                                                            <option>CL-001</option>
                                                            <option>CL-002</option>
                                                            <option>CL-003</option>
                                                            <option>CL-004</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td className="hd-s2 pl10">
                                                    <p>Owner</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <select
                                                        type="text"
                                                        className="form-select"
                                                    >
                                                        <option>
                                                            Select Owner
                                                        </option>
                                                    </select>
                                                </td>
                                                <td className="hd-s2">
                                                    <p>Yard</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <div className="hull-select-box">
                                                        <select className="form-select">
                                                            <option>Select Yard Number</option>
                                                            <option>CL-001</option>
                                                            <option>CL-002</option>
                                                            <option>CL-003</option>
                                                            <option>CL-004</option>
                                                        </select>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="about-inspection-report">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="hd-s2">
                                                    <p>Remark:</p>
                                                </td>
                                                <td className="hd-s2">
                                                    <p>
                                                        <span>AA</span>: Accepted
                                                    </p>
                                                </td>
                                                <td className="hd-s2">
                                                    <p>
                                                        <span>QCC</span>: to be confirmed by Q.A
                                                    </p>
                                                </td>
                                                <td className="hd-s2">
                                                    <p>
                                                        <span>OWC</span>: to be confirmed by Owner
                                                    </p>
                                                </td>
                                                <td className="hd-s2">
                                                    <p>
                                                        <span>PP</span>: Pending
                                                    </p>
                                                </td>
                                                <td className="hd-s2">
                                                    <p>
                                                        <span>NA</span>: Rejected
                                                    </p>
                                                </td>
                                                <td className="hd-s2">
                                                    <p>
                                                        <span>CXL</span>: Cancelled
                                                    </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="appraisal-report-table-responsive">
                                    <table className="assessment-table" cellSpacing={0}>
                                        <tbody>
                                            <tr>
                                                <td className="hd-s2 pd10">
                                                    {" "}
                                                    <p>S.No.</p>
                                                </td>
                                                <td className="hd-s2 pd10">
                                                    <p>Date</p>
                                                </td>
                                                <td className="hd-s2 pd10">
                                                    <p>Inspection Area</p>
                                                </td>
                                                <td className="hd-s1 pd10">
                                                    <p>Inspection Item</p>
                                                </td>
                                                <td className="hd-s2 pd10">
                                                    <p>Type of Inspection</p>
                                                </td>
                                                <td className="hd-s2 pd10">
                                                    <p>Comments &amp; Remark</p>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>Result</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">1.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Enter Date"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Area"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Item "
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Type of Inspection"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">2.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Enter Date"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Area"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Item "
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Type of Inspection"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">3.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Enter Date"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Area"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Item "
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Type of Inspection"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">4.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Enter Date"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Area"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Item "
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Type of Inspection"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">5.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Enter Date"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Area"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Inspection Item "
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Type of Inspection"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr className="addmoreitem">
                                                <td className="td-s1" colSpan={7}>
                                                    <button type="button" className="btn btn-link">
                                                        + Add New Item
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-lg-12 text-left ">
                                        <a
                                            href="ship-inspection-progress-list.php"
                                            className="btn btn-success"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Submit
                                        </a>
                                        <button
                                            type="reset"
                                            className="btn btn-danger ms-3"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default DailyInspectionReport